@if (!merchant()) {
	Not Found
} @else {
	<router-outlet />
}
